import type { Language } from "@/i18n/LanguageContext";

const localeMap: Record<Language, string> = {
  de: "de-DE",
  en: "en-GB",
  fr: "fr-FR",
  es: "es-ES",
  it: "it-IT",
};

export const getBookingUrl = (language: Language): string => {
  const locale = localeMap[language];
  return `https://bookingengine.mylighthouse.com/esos-hotel-quelle-switzerland?language=${locale}`;
};
